import { Pair } from "widgets-for-react";
import { StyleguideImgPlaceholder } from "../../../styleguide/helpers";
import { ImageSize } from "../../cms/blocks/types.gen";
import { WordPress } from "../../wordpress/wordpress_api";

export type ExtraImages = 
  'header_s'| 'header_m'| 'header_l'| 'header_xl' |
  'story_header_s'| 'story_header_m'| 'story_header_l'|
  'media_block_s'| 'media_block_m'| 'media_block_l' |
  'portrait_s'| 'portrait_m'| 'portrait_l'| 'portrait_xl'


export let get_default_data_src: () => ImageSize<ExtraImages> = () => "full"
export let get_default_data_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () =>
  [
    //example: mk_pair('media_w432' as ExtraImages, "424w"),
  ]

export function getImageSize<t>(media: WordPress.Image, size: string | ImageSize<t>): string {
  let image_size: string = size.toString()
  return media && media.media_details && media.media_details.sizes && media.media_details.sizes[image_size] && media.media_details.sizes[image_size].source_url ?
    media.media_details.sizes[image_size].source_url
    : media.source_url;
}

export function getImageAttribute<t>(media: WordPress.Image, size: string | ImageSize<t>, attr: string): string {
  let image_size: string = size.toString()
  if (media && media.media_details && media.media_details.sizes && media.media_details.sizes) {
    return media.media_details.sizes[image_size] && media.media_details.sizes[image_size][attr] ?
      media.media_details.sizes[image_size][attr]
      : media.media_details.sizes['full'] && media.media_details.sizes['full'][attr] ?
        media.media_details.sizes['full'][attr]
        : ''
  }

  return ''
}

export const placeholderImage: (alt) => WordPress.Image = (alt) => {
  return {
    alt_text: alt,
    post: 9999,
    source_url: '',
    id: 1337,
    date: '',
    date_gmt: '',
    guid: {
      rendered: ''
    },
    modified: '',
    modified_gmt: '',
    slug: 'placeholder',
    status: 'inherit',
    type: 'attachment',
    link: '',
    title: {
      rendered: '',
    },
    author: 1337,
    comment_status: 'open',
    ping_status: 'open',
    template: '',
    meta: [],
    acf: [],
    description: {
      rendered: ''
    },
    caption: {
      rendered: ''
    },
    media_type: 'image',
    mime_type: 'image/jpeg',
    media_details: {
      file: '',
      height: 0,
      width: 0,
      image_meta: {
        aperture: '',
        credit: '',
        camera: '',
        caption: '',
        created_timestamp: '',
        copyright: '',
        focal_length: '',
        iso: '',
        shutter_speed: '',
        title: '',
        orientation: 'landscape',
        keywords: []
      },
      sizes: {
        full: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600,
          width: 900,
          source_url: StyleguideImgPlaceholder({ shape: { width: 1600, height: 900, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })
        },
        large: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600,
          width: 900,
          source_url: StyleguideImgPlaceholder({ shape: { width: 1600, height: 900, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })
        },
        medium_large: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600,
          width: 900,
          source_url: StyleguideImgPlaceholder({ shape: { width: 1600, height: 900, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })
        },
        medium: {
          mime_type: 'image/jpeg',
          file: '',
          height: 1600,
          width: 900,
          source_url: StyleguideImgPlaceholder({ shape: { width: 1600, height: 900, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })
        },
      }
    }
  }
}
